export function shouldEnableInitialUserInfoQuery(
  slWorkspaceEnabled: boolean,
  hasLoginMarker: boolean
): boolean {
  return slWorkspaceEnabled || hasLoginMarker;
}
